import {
  MY_PROGRESS_ITEM,
  MY_PROGRESS_WORD_WALL_ITEM,
  REPORTS_MENU_CLASSROOM_DATA_ITEM,
  REPORTS_MENU_POWER_WORDS_ITEM,
  REPORTS_MENU_USAGE_REPORT_ITEM,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

export const useGetReportsMenuSectionProps = () => {
  const { data: user } = useUser();
  const { isStaff, isStudent, canAdminViewUsageReport } = getUserProperties(
    user,
    { shouldUseNewUserApi: false },
  );

  const reportsMenuSectionTitle = isStudent ? "My progress" : "Reports";

  const reportsMenuSectionItems = [];

  if (isStudent) {
    reportsMenuSectionItems.push(MY_PROGRESS_ITEM);
    reportsMenuSectionItems.push(MY_PROGRESS_WORD_WALL_ITEM);

    return {
      reportsMenuSectionTitle,
      reportsMenuSectionItems,
    };
  }

  // Classroom data
  reportsMenuSectionItems.push(REPORTS_MENU_CLASSROOM_DATA_ITEM);

  // Power words
  reportsMenuSectionItems.push(REPORTS_MENU_POWER_WORDS_ITEM);

  // Usage report
  if (canAdminViewUsageReport || isStaff) {
    reportsMenuSectionItems.push(REPORTS_MENU_USAGE_REPORT_ITEM);
  }

  return {
    reportsMenuSectionTitle,
    reportsMenuSectionItems,
  };
};
